import React from "react";
import { injectIntl } from "react-intl";
import { useHistory, useRouteMatch } from "react-router-dom";
import ButtonPreloader from "@FormComponents/ButtonPreloader";
const searchParamsStringify = require("@Utils/searchParamsStringify");

function PagerShowMore({ intl, searchParams, totalMatches, itemsPerPage, loadingResult, setLoadingResult }) {
    const route = useRouteMatch();
    const history = useHistory();
    const currentPage = searchParams.page ? parseInt(searchParams.page) : 1;
    let resultsCount = itemsPerPage * currentPage > totalMatches ? totalMatches : itemsPerPage * currentPage;
    let resultsLeft = totalMatches - resultsCount;

    if (resultsLeft === 0) {
        return null;
    }

    const indicatoWidth = (resultsCount / totalMatches) * 100;

    let baseUrl = route.path.replace(':searchParams*', '');
    if (route && route.params && route.params.clientName) {
        baseUrl = baseUrl.replace(":clientName", route.params.clientName)
    }

    const nextPageUrl = () => {
        searchParams.page = currentPage + 1;
        const params = searchParamsStringify(searchParams);

        return `${baseUrl}${params}`;
    }
    const loadMore = event => {
        event.preventDefault();
        setLoadingResult(true)
        const pageUrl = nextPageUrl();

        history.push(pageUrl);
    }

    return(
        <>
            <div className="bg-brand--off-white show-more">
              <div className="show-more__indicator">
                <div className="indicator-percentage">
                  <div className="indicator-percentage__background">
                      <div className="indicator-percentage__amount" style={{width: `${indicatoWidth}%`}}/>
                  </div>
                </div>
              </div>
              <div className="section-separator section-separator--border">
                <span className="bg-brand-tertiary">
                  { intl.formatMessage({id: "PagerShowMore.ResultsOf"}, {results: resultsCount, total: totalMatches})}
                </span>
              </div>
              <ButtonPreloader className="button button--m bluex-button--preloader" onClick={loadMore} disabled={loadingResult}>
              <span className="button__text">
                {
                    intl.formatMessage({id: "PagerShowMore.ViewMore"}, {
                        count: resultsLeft <= itemsPerPage ? resultsLeft : itemsPerPage
                    })
                }
              </span>
              </ButtonPreloader>
            </div>
        </>
    );
}

export default injectIntl(PagerShowMore);